const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Chip/Chip.tsx';
import { css, cx } from '@emotion/css';
import { ReactNode, useMemo } from 'react';
import { ColorSettings, getColorSettings, Severity } from '../utils';
import { useTheme } from '@mui/material/styles';

interface Props {
    children: ReactNode;
    color?: Severity | ColorSettings;
    className?: string;
}

function useCSSClasses(color: string | undefined, backgroundColor: string | undefined) {
    const theme = useTheme();
    return useMemo(
        () => ({
            // little workaround to get the dialog to have a fixed distance from top and bottom
            chipCss: css`
                display: flex;
                align-items: center;
                background-color: ${backgroundColor ?? 'transparent'};
                color: ${color ?? 'inherit'};
                height: 20px;
                border-radius: 2px;
                padding: 0 4px;
                line-height: 20px;
                overflow: hidden;
                width: fit-content;

                > span {
                    flex: unset !important;
                }
            `,
        }),
        [theme, color, backgroundColor]
    );
}

export const Chip = (props: Props) => {
    const { color, backgroundColor } = getColorSettings('chip', props.color);
    const classes = useCSSClasses(color, backgroundColor);
    return <div className={cx(classes.chipCss, props.className)}>{props.children}</div>;
};
